import React from 'react'
import { ListGroup, Form, Button } from 'react-bootstrap'

const CreatedGroup = () => {
  return (
    <div 
      style={{minHeight:"400px"}} 
      className='p-2 p-md-4 h-100 m-2 shadow rounded'
    >
      <p className='display-6'>Example Group</p>
      <ListGroup style={{minHeight:"200px", maxHeight:"230px", overflow:"auto"}}>
        <ListGroup.Item className='d-flex justify-content-between'><p>Cras</p><p>Cras@example.com</p></ListGroup.Item>
        <ListGroup.Item className='d-flex justify-content-between'><p>Dapibus</p><p>Dapibus@example.com</p></ListGroup.Item>
        <ListGroup.Item className='d-flex justify-content-between'><p>Morbi</p><p>Morbi@example.com</p></ListGroup.Item>
        <ListGroup.Item className='d-flex justify-content-between'><p>Porta</p><p>Porta@example.com</p></ListGroup.Item>
        <ListGroup.Item className='d-flex justify-content-between'><p>Vestibulum</p><p>Vestibulum@example.com</p></ListGroup.Item>
        <ListGroup.Item className='d-flex justify-content-between'><p>Cras</p><p>Cras@example.com</p></ListGroup.Item>
        <ListGroup.Item className='d-flex justify-content-between'><p>Dapibus</p><p>Dapibus@example.com</p></ListGroup.Item>
        <ListGroup.Item className='d-flex justify-content-between'><p>Morbi</p><p>Morbi@example.com</p></ListGroup.Item>
        <ListGroup.Item className='d-flex justify-content-between'><p>Porta</p><p>Porta@example.com</p></ListGroup.Item>
        <ListGroup.Item className='d-flex justify-content-between'><p>Vestibulum</p><p>Vestibulum@example.com</p></ListGroup.Item>
        <ListGroup.Item className='d-flex justify-content-between'><p>Cras</p><p>Cra@example.com</p></ListGroup.Item>
        <ListGroup.Item className='d-flex justify-content-between'><p>Dapibus</p><p>Dapibus@example.com</p></ListGroup.Item>
        <ListGroup.Item className='d-flex justify-content-between'><p>Morbi</p><p>Morbi@example.com</p></ListGroup.Item>
        <ListGroup.Item className='d-flex justify-content-between'><p>Porta</p><p>Porta@example.com</p></ListGroup.Item>
        <ListGroup.Item className='d-flex justify-content-between'><p>Vestibulum</p><p>Vestibulum@example.com</p></ListGroup.Item>
        <ListGroup.Item className='d-flex justify-content-between'><p>Cras</p><p>Cras@example.com</p></ListGroup.Item>
        <ListGroup.Item className='d-flex justify-content-between'><p>Dapibus</p><p>Dapibus@example.com</p></ListGroup.Item>
        <ListGroup.Item className='d-flex justify-content-between'><p>Morbi</p><p>Morbi@example.com</p></ListGroup.Item>
        <ListGroup.Item className='d-flex justify-content-between'><p>Porta</p><p>Porta@example.com</p></ListGroup.Item>
        <ListGroup.Item className='d-flex justify-content-between'><p>Vestibulum</p><p>Vestibulum@example.com</p></ListGroup.Item>
      </ListGroup>
      <Form className='pt-4 w-100 m-auto'>
        <Form.Group className="mb-3" controlId="formEmail">
          <Form.Label>Subject</Form.Label>
          <Form.Control className='py-2 px-3 fs-5' required type="text" placeholder="A Discount" />
        </Form.Group>
        <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
          <Form.Label>Example textarea</Form.Label>
          <Form.Control as="textarea" rows={3} />
        </Form.Group>
        {/* <p className='text-danger' id="sign-in-error-text">{errText}</p> */}
        <Button className='py-2 w-100 px-5 mt-3 fs-4' variant="outline-dark" type="submit">
          Submit
        </Button>
      </Form>
    </div>
  )
}

export default CreatedGroup